const entityType: {
    [keys: string]: string;
} = {
    CARD_NUMBER: "card number",
    CARD_EXPIRY_DATE: "expiry date",
    SSN: "national id",
    ZIPCODE: "postal code",
    PII_OTHER: "sensitive data",
    PHONE_NUMBER: "phone",
    PERSON: "name",
    GEO: "location",
    USER_INFO: "user info",
    EMAIL: "email",
};

export default {
    _prefix: "evaluation.assistance",
    topics: (data: { count: number }) => {
        return "{{count}} Topics:";
    },
    topic: (data: { count: number }) => {
        return "{{count}} Topic:";
    },
    phrases: (data: { count: number }) => {
        return "{{count}} phrases detected";
    },
    recognizedNamedEntities: entityType,
    labels: {
        topic: "Topic:",
        topics: "Topics:",
        included: "Included",
        andExcluded: "AND Excluded",
        excluded: "Excluded",
        sbDeletedTopic: "[Deleted Topic]",
    },
};
